import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DATA, PageNode, PartieMachineNode, PartieMachineNodeAugmented } from '../reducer/data.reducer';

export interface PageWithDisplayName extends PageNode {
    displayName: string;
}

export interface PartieMachineNodeWithDetails extends PartieMachineNodeAugmented {
    // overrides to include pages with display names
    page: PageWithDisplayName[];
    displayName: string;
}


export const selectDataState = createFeatureSelector<DATA>('data');

export const selectPartieMachineNodes = createSelector(
  selectDataState,
  (state: DATA) => state.pages
);

export const selectPartieMachineNodesWithDetails = createSelector(
    selectPartieMachineNodes,
    (partieMachines: DATA['pages']): PartieMachineNodeWithDetails[] => {
        return partieMachines.map((partieMachine) => {
            const pagesWithDisplayNames: PageWithDisplayName[] = partieMachine.page.map((page) => {
                const displayName = page['@attributes'].desan || page['@attributes'].desfr || page['@attributes'].desal
                  || '';
                return {
                    ...page,
                    displayName
                };
            });
            const partieMachineName = partieMachine['@attributes'].desan || partieMachine['@attributes'].desfr || partieMachine['@attributes'].desal || '';
            return {
                ...partieMachine,
                page: pagesWithDisplayNames,
                displayName: partieMachineName
            } as PartieMachineNodeWithDetails;
        });
    }
);